import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { useState as l, useRef as c } from "react";
import { ChevronDownIcon as d } from "../Icons/basic/ChevronDownIcon.js";
import { tv as p } from "../tailwind-variants.config.js";
const f = p({
  base: "jm-grid jm-gap-1 jm-overflow-hidden jm-transition-all jm-duration-300 jm-ease-in-out",
  variants: {
    open: {
      true: "jm-mt-2"
    }
  }
}), x = ({ title: o, content: s, defaultOpen: a = !1 }) => {
  var m;
  const [r, i] = l(a), t = c(null);
  return /* @__PURE__ */ n("div", { className: "jm-font-paragraph-1 jm-grid", children: [
    /* @__PURE__ */ n(
      "div",
      {
        className: "jm-flex jm-cursor-pointer jm-justify-between jm-rounded-lg jm-bg-jutro-new-warm-gray-50 jm-p-4 jm-text-jutro-new-warm-gray-800",
        onClick: () => i((j) => !j),
        children: [
          /* @__PURE__ */ e("div", { className: "jm-font-label jm-select-none", children: o }),
          /* @__PURE__ */ e(
            "div",
            {
              className: `jm-h-6 jm-transition-transform ${r && "jm-custom-rotate-180"}`,
              children: /* @__PURE__ */ e(d, {})
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ e(
      "div",
      {
        ref: t,
        className: f({ open: r }),
        style: {
          maxHeight: r ? `${(m = t.current) == null ? void 0 : m.scrollHeight}px` : "0px"
        },
        children: s
      }
    )
  ] });
};
export {
  x as Accordion
};
//# sourceMappingURL=index.js.map
